import { render } from "./FindStudents.vue?vue&type=template&id=0b798a8a"
import script from "./FindStudents.vue?vue&type=script&lang=js"
export * from "./FindStudents.vue?vue&type=script&lang=js"

import "./FindStudents.vue?vue&type=style&index=0&id=0b798a8a&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__